<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
};
</script>

<style lang="scss">
html,
body,
#app,
.v-application,
.v-main {
  height: 100vh !important;
  margin: 0;
  padding: 0;
  font-family: "Open Sans", Arial, Helvetica, sans-serif;
  overflow: hidden !important;
}

.custom-orange {
  color: #f37121;
}

.custom-pink {
  color: #f491af;
}

.custom-yellow {
  color: #e3d80d;
}

.custom-light-blue {
  color: #0085c4;
}

.custom-green {
  color: #44b651;
}

.custom-dark-blue {
  color: #0057a7;
}

.custom-fuschia {
  color: #b43688 !important;
}

.custom-poppy {
  color: #e24149;
}

.custom-grey {
  color: #efede4;
}

.custom-background-color {
  background-color: #efede4 !important;
}

a {
  text-decoration: none !important;
}

.v-btn__content {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
}

.line {
  width: 30px;
  height: 20px;
  margin-bottom: 15px;
  margin-left: 20px;
  margin-right: 20px;
  border-bottom: 2px solid #efede4;
}

// Common layout styles for pages
.page-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #eb63eb;
  position: relative;
  overflow: hidden;
}

.scrollable-content {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 20px;
}

.fixed-bottom-buttons {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

// Common header section styles
.header-section {
  background: #eb63eb;
  padding-bottom: 20px;
  position: relative;
  z-index: 2;
  min-height: 26vh;
  max-height: 26vh;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.header-content {
  padding: 30px 24px 0;
  text-align: center;
  width: 100%;
}

.header-title {
  color: white;
  font-size: 32px;
  font-weight: 900;
  font-family: "Montserrat", sans-serif;
  text-align: center;
  margin: 0 0 20px 0;
  line-height: 1;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.header-subtitle {
  color: white;
  font-size: 16px;
  font-weight: 500;
  font-family: "Montserrat", sans-serif;
  margin: 0;
  line-height: 1.3;
}

// Common content section styles
.content-section {
  flex: 1;
  background: #80b0eb;
  border-radius: 45px 45px 0 0;
  margin-top: 0;
  position: relative;
  z-index: 2;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.content-inner {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 3;
  overflow: hidden;
  min-height: 0;
  margin-bottom: 40px;
}

// Common button styles
.quiz-button-container {
  display: flex;
  justify-content: center;
  padding: 40px 0 20px 0;
  margin-top: 40px;
}

.quiz-button {
  background: #eb63eb !important;
  color: white !important;
  border-radius: 12px !important;
  font-weight: bold !important;
  font-size: 16px !important;
  text-transform: none !important;
  padding: 0 32px !important;
  height: 50px !important;
  min-width: 200px !important;
  box-shadow: 0 4px 12px rgba(235, 99, 235, 0.3) !important;
}

// .v-divider {
//   display: block;
//   flex: 1 1 0px;
//   max-width: 100%;
//   height: 2px;
//   max-height: 0px;
//   border: solid;
//   border-width: thin 0 0 0;
//   transition: inherit;
// }

.note {
  color: #666;
  font-size: 14px;
}

strong {
  color: #666 !important;
  font-weight: 900 !important;
}

ul {
  padding-left: 20px;
  line-height: 1.5;
}

li {
  margin-bottom: 12px;
}

h2,
h3,
h4 {
  color: #333;
  margin-bottom: 12px;
}

p {
  margin-bottom: 12px;
  line-height: 1.5;
}

// Ring-specific styles (orange/yellow theme)
.ring-highlight {
  color: #eba614;
  font-weight: 600;
}

.ring-title {
  color: #eba614;
}

.ring-bullet {
  color: #eba614;
}

// Oral pills-specific styles (blue theme)
.pills-highlight {
  color: #3d80e8;
  font-weight: 600;
}

.pills-title {
  color: #3d80e8;
}

.pills-bullet {
  color: #3d80e8;
}

// Injection-specific styles (purple theme)
.injection-highlight {
  color: #8e44ad;
  font-weight: 600;
}

.injection-title {
  color: #8e44ad;
}

.injection-bullet {
  color: #8e44ad;
}
// Injection-specific styles (pink/magenta theme)
.injection2-highlight {
  color: #e91e63;
  font-weight: 600;
}

.injection2-title {
  color: #e91e63;
}

.injection2-bullet {
  color: #e91e63;
}
</style>
